export default {"src":"/_next/static/media/ic-filedownload-blue.ec4d4c8c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};